import { Utils } from '@/utils/Utils';
import { GUID } from '@/utils/guid';
import { ACTION } from '@/store/ACTION';
import { Counter, ICounter } from '@/utils/Counter';

class PromoWebSocket extends WebSocket {
  isOpen: boolean = false;
  pingId: any = false;

  config: any = {
    login: {
      command: 'login',
      data: {
        sid: Utils.parseGetParams('sid'),
        gid: String(initConfig.gameIdentificationNumber)
      }
    },
    ping: {
      command: 'ping'
    },
    get: {
      tournament_players: {
        command: 'get',
        query: 'tournamentTable',
        data: {
          id: 0
        }
      }
    }
  };

  private _pingOutOfConnection: ICounter = new Counter(0, 3);

  initFunctions(): void {
    this.addEventListener('open', this.onOpen);
    this.addEventListener('close', this.onClose);
    this.addEventListener('error', this.onError);
    this.addEventListener('message', this.onMessage);
  }
  onOpen(): void {
    this.isOpen = true;
    this.sendLoginData();
    this.startSendPing();
  }
  onError(): void {
    this.isOpen = false;
    this.stopSendPing();
  }

  onClose(): void {
    this.isOpen = false;
    this.stopSendPing();
  }

  private sendPingWrapper(): void {
    this.countPingOutOfConnection();

    if (this._pingOutOfConnection.isComplete) {
      this.close();
      return;
    }

    this.send(this.config.ping);
  }

  private countPingOutOfConnection(): void {
    if (navigator.onLine) {
      this._pingOutOfConnection.reset();
      return;
    }

    if (this._pingOutOfConnection.isComplete) return;

    this._pingOutOfConnection.addOne();
  }

  startSendPing() {
    this.pingId = setInterval(this.sendPingWrapper.bind(this), 5000);
  }

  stopSendPing() {
    clearInterval(this.pingId);
    this.pingId = null;
  }

  override send(data: any | ArrayBufferLike | Blob | ArrayBufferView) {
    if (!this.isOpen) return;
    if (data.command !== 'ping') data.messageId = GUID.create();
    data = JSON.stringify(data);
    super.send(data);
  }

  onMessage(data: any): void {
    data = JSON.parse(data.data);
    if (data.command === 'error') {
      console.error(`PROMO ERROR: ${data.data.message}`);
      return;
    }
    promoApp.eventEmitter.emit(ACTION.SET_MESSAGE, data);
  }

  queryTournamentPlayers(id: number): any {
    this.config.get.tournament_players.data.id = id;
    this.send(this.config.get.tournament_players);
  }

  sendLoginData(): void {
    this.send(this.config.login);
  }
}

export { PromoWebSocket };
